/**
 * Co Host role. Must be an XMPP moderator.
 */
export const IC_ROLE_COHOST = 'IC_ROLE_COHOST';
/**
 * Captioner role.
 */
export const IC_ROLE_CAPTIONER = 'IC_ROLE_CAPTIONER';
/**
 * Sign language translator.
 */
export const IC_ROLE_SIGN_LANG_TRANSLATOR = 'IC_ROLE_SIGN_LANG_TRANSLATOR';
/**
 * Assistant role.
 */
export const IC_ROLE_ASSISTANT = 'IC_ROLE_ASSISTANT';
/**
 * Additional role. Is set if someone is assisted by another user.
 */
export const IC_ROLE_ASSISTED = 'IC_ROLE_ASSISTED';
/**
 * Role collection.
 */
export var IC_ROLES;
(function (IC_ROLES) {
    IC_ROLES["COHOST"] = "IC_ROLE_COHOST";
    IC_ROLES["CAPTIONER"] = "IC_ROLE_CAPTIONER";
    IC_ROLES["SIGN_LANG_TRANSLATOR"] = "IC_ROLE_SIGN_LANG_TRANSLATOR";
    IC_ROLES["ASSISTANT"] = "IC_ROLE_ASSISTANT";
    IC_ROLES["ASSISTED"] = "IC_ROLE_ASSISTED";
})(IC_ROLES || (IC_ROLES = {}));
